import React from "react";

/** Engine cluster · blue/green migration. */
export default function EngineClusterPanel({ engine, engineNodes, migrations, migrating, migrateTo }) {
  return (
    <>
          {/* Engine nodes cluster — blue/green migration */}
          <div className="border-t border-zinc-800 pt-4" data-testid="engine-nodes-section">
            <div className="flex items-baseline justify-between mb-2">
              <div>
                <div className="font-display font-bold">Engine cluster · blue/green migration</div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
                  daemons registered · {engineNodes.length} · currently on
                  <span className="text-emerald-400"> {engine?.node_id || "—"}</span>
                </div>
              </div>
            </div>
            <div className="space-y-1">
              {engineNodes.map((n) => {
                const isHere = n.node_id === engine.node_id;
                const pipes = n.pipelines || [];
                return (
                  <div
                    key={n.node_id}
                    data-testid={`node-row-${n.node_id}`}
                    className={`flex items-center gap-2 border rounded-sm px-2 py-1.5 font-mono text-[11px] ${
                      isHere ? "border-emerald-500/50 bg-emerald-500/5" : "border-zinc-800 bg-black/30"
                    }`}
                  >
                    <span className={`w-2 h-2 rounded-full ${n.status === "online" ? "bg-emerald-500" : "bg-red-500"}`} />
                    <span className="w-28 text-zinc-100">{n.node_id}</span>
                    <span className="w-32 text-zinc-500 truncate" title={n.gpu_model}>{n.gpu_model}</span>
                    <span className="w-16 text-zinc-400">
                      CPU {n.system?.cpu_pct ?? "—"}%
                    </span>
                    <span className="w-16 text-zinc-400">
                      MEM {n.system?.mem_pct ?? "—"}%
                    </span>
                    <span className="w-20 text-zinc-400">pipes {pipes.length}</span>
                    <span className="flex-1 text-zinc-500">
                      hb {n.heartbeat_age_sec != null ? `${n.heartbeat_age_sec}s` : "—"}
                    </span>
                    {isHere ? (
                      <span className="text-[10px] uppercase tracking-widest text-emerald-400 border border-emerald-500/40 px-2 py-0.5 rounded-sm">HOSTING</span>
                    ) : (
                      <button
                        onClick={() => migrateTo(n.node_id)}
                        disabled={migrating || n.status !== "online"}
                        data-testid={`migrate-btn-${n.node_id}`}
                        className="text-[10px] uppercase tracking-widest border border-blue-500/60 text-blue-400 px-2 py-0.5 rounded-sm hover:bg-blue-500/10 disabled:opacity-40"
                      >
                        Migrate here
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
            {migrations.length > 0 && (
              <div className="border border-zinc-800 rounded-sm bg-black/40 p-2 mt-2" data-testid="migrations-history">
                <div className="text-[9px] text-zinc-500 uppercase tracking-widest mb-1">Recent migrations</div>
                <div className="space-y-0.5 font-mono text-[10px]">
                  {migrations.slice(0, 5).map((m) => (
                    <div key={m.id} className="flex items-center gap-2">
                      <span className={`w-16 uppercase ${m.state === "done" ? "text-emerald-400" : m.state === "failed" ? "text-red-400" : "text-amber-400"}`}>{m.state}</span>
                      <span className="w-32 text-zinc-500">{m.from_node_id}</span>
                      <span className="text-zinc-500">→</span>
                      <span className="w-32 text-zinc-100">{m.to_node_id}</span>
                      <span className="w-20 text-zinc-500">{m.overlap_sec}s overlap</span>
                      <span className="text-zinc-500">by {m.initiated_by}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

    </>
  );
}
